export interface WhiteLableWebsiteType {
  key: string;
  domain: string;
  whitelabel: string;
  logo: {
    filename: string;
    width: string;
    height: string
  };
  name: string;
  loginImage: {
    width: string;
    height: string
  },
  isShowingName: boolean

}

export const whiteLabels: WhiteLableWebsiteType[] = [
  {
    key: "default",
    domain: "admin.kwikmemories.com",
    whitelabel: "admin.kwikmemories.com",
    name: "KwikMemories",
    isShowingName: true,
    loginImage: {
      width: "185px",
      height: "170px"
    },
    logo: {
      filename: "kwikmediaLogo.webp",
      width: "60%",
      height: "145px"
    }

  },
  {
    key: "locahost",
    domain: "localhost:3000",
    whitelabel: "localhost:3000",
    name: "KwikMemories",
    isShowingName: true,
    loginImage: { width: "190px", height: "190px" },
    logo: { filename: "kwikmediaLogo.webp", width: "auto", height: "190px" },
  },
  {
    key: "AshokPhotography",
    domain: "ashokphotography.admin.kwikmemories.com",
    whitelabel: "ashokphotography.admin.kwikmemories.com",
    name: "Ashok Photography",
    loginImage: {
      width: "130px",
      height: "130px"
    },
    logo: {
      filename: "ashokPhotography.png",
      width: "100px",
      height: "100px"
    },
    isShowingName: false,
  },
  {
    key: "BollywoodStudios",
    domain: "bollywoodstudios.admin.kwikmemories.com",
    whitelabel: "bollywoodstudios.admin.kwikmemories.com",
    name: "Bollywood Studios",
    loginImage: {
      width: "210px",
      height: "120px"
    },
    logo: {
      filename: "bollywoodstudio.png",
      width: "250px",
      height: "100px"
    },
    isShowingName: false,
  },
  {
    key: "Dhiyoyo",
    domain: "dhiyoyo.admin.kwikmemories.com",
    whitelabel: "dhiyoyo.admin.kwikmemories.com",
    name: "Dhiyoyo Studio",
    loginImage: {
      width: "130px",
      height: "130px"
    },
    logo: {
      filename: "DhiyoyoStudio.png",
      width: "100px",
      height: "100px"
    },
    isShowingName: false,
  },
  {
    key: "MahaveerFilms",
    domain: "mahaveerfilms.admin.kwikmemories.com",
    whitelabel: "mahaveerfilms.admin.kwikmemories.com",
    name: "Mahaveer Films",
    loginImage: {
      width: "130px",
      height: "130px"
    },
    logo: {
      filename: "MahaveerFilmsLogo.png",
      width: "100px",
      height: "100px"
    },
    isShowingName: false,
  },
];

export const getWhiteLableObject = () => {
  const host = window.location.hostname;

  const website = whiteLabels.filter((wb: WhiteLableWebsiteType) => {
    return host == wb.domain || host === wb.whitelabel;
  });
  if (website && website.length) {
    return website[0];
  } else {
    return whiteLabels[0];
  }
};

export function setHeadMeta({
  title,
  favicon,
  appleTouchIcon,
}: {
  title?: string;
  favicon?: string;
  appleTouchIcon?: string;
}) {
  if (title) {
    document.title = title;
  }

  if (favicon) {
    let faviconTag =
      document.querySelector<HTMLLinkElement>("link[rel*='icon']");
    if (!faviconTag) {
      faviconTag = document.createElement("link");
      faviconTag.rel = "icon";
      document.head.appendChild(faviconTag);
    }
    faviconTag.href = favicon;
  }

  if (appleTouchIcon) {
    let appleTag = document.querySelector<HTMLLinkElement>(
      "link[rel='apple-touch-icon']"
    );
    if (!appleTag) {
      appleTag = document.createElement("link");
      appleTag.rel = "apple-touch-icon";
      document.head.appendChild(appleTag);
    }
    appleTag.href = appleTouchIcon;
  }
}
